import { toastController } from '@ionic/vue';

export const SNACKBAR = {
  SHORT: 2000,
  DEFAULT: 2500,
  ERROR: 3500,
};

const DEFAULT_OPTIONS = {
  duration: SNACKBAR.DEFAULT,
  position: 'bottom',
};

const NAV_DELAY_MS = 800;

/**
 * Shows an Ollaa-styled snackbar (black, bottom-centered).
 * @param {string} message
 * @param {{ duration?: number, position?: 'top' | 'bottom' | 'middle' }} [options]
 * @returns {Promise<HTMLIonToastElement | null>}
 */
export async function showSnackbar(message, options = {}) {
  const { duration, position } = { ...DEFAULT_OPTIONS, ...options };

  try {
    const toast = await toastController.create({
      message,
      duration,
      position,
      cssClass: 'ollaa-snackbar',
    });

    await toast.present();
    return toast;
  } catch (error) {
    console.warn('showSnackbar failed:', error);
    return null;
  }
}

export const snackbarSuccess = (message) => showSnackbar(message, { duration: SNACKBAR.DEFAULT });

export const snackbarError = (message) => showSnackbar(message, { duration: SNACKBAR.ERROR });

/**
 * @param {HTMLIonToastElement | null} toast
 * @returns {Promise<void>}
 */
export async function awaitSnackbarDismiss(toast) {
  if (!toast) return;
  await new Promise((resolve) => {
    toast.onDidDismiss().then(resolve);
  });
}

/**
 * Shows a snackbar after navigation so it is not cut off by route transitions.
 * @param {string} message
 * @param {{ duration?: number }} [options]
 * @returns {Promise<HTMLIonToastElement | null>}
 */
export function showSnackbarAfterNav(message, options = {}) {
  return new Promise((resolve) => {
    setTimeout(async () => {
      resolve(await showSnackbar(message, options));
    }, NAV_DELAY_MS);
  });
}
